/**
 * Dominican peso.
 */
export var DOP = {
  code: 'DOP',
  base: 10,
  exponent: 2
};